const isBlank = value => value === undefined || value === null || value === ''

const serializeParams = params => Object.entries(params || {})
  .flatMap(([key, value]) => {
    if (isBlank(value)) return []
    if (Array.isArray(value)) {
      if (!value.length) return []

      return [[key, value.join(',')]]
    }

    return [[key, value]]
  })
  .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
  .join('&')

export default serializeParams
